import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, postAction, httpAction } from '@api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { ajaxGetDictItems, newRange, queryRange } from '@/api/api';
import pick from 'lodash.pick';
var paramColumns = [{
  title: '量程名称',
  dataIndex: 'rangeName',
  align: 'center',
  width: '30%',
  scopedSlots: {
    customRender: 'rangeName'
  }
}, {
  title: '量程值',
  dataIndex: 'rangeValue',
  align: 'center',
  width: '40%',
  scopedSlots: {
    customRender: 'rangeValue'
  }
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var partColumns = [{
  title: '关键参数',
  dataIndex: 'keyParameterStr',
  key: 'keyParameterStr',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'keyParameterStr'
  }
}, {
  title: '最小值',
  dataIndex: 'minValue',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'minValue'
  }
}, {
  title: '最大值',
  align: 'center',
  dataIndex: 'maxValue',
  width: '20%',
  scopedSlots: {
    customRender: 'maxValue'
  }
}, {
  title: '单位',
  dataIndex: 'unit',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'unit'
  }
}];
var parameterFilingItems = [{
  keyParameterStr: '1',
  kparameter: '测量量程',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '2',
  kparameter: '测量精度',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '3',
  kparameter: '测量间隔',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '4',
  kparameter: '消解温度',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStrParameter: '5',
  kparameter: '消解时长',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '6',
  kparameter: '曲线截距',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStrParameter: '7',
  kparameter: '曲线斜率',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '8',
  kparameter: '测量检出线',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStrParameter: '9',
  kparameter: '测量信号值',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '10',
  kparameter: '线性相关系数',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStrParameter: '11',
  kparameter: '二次多项式系数',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '12',
  kparameter: '稀释倍数',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '13',
  kparameter: '三项式系数',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '14',
  kparameter: '空白标定系数',
  minValue: '',
  maxValue: '',
  unit: ''
}, {
  keyParameterStr: '15',
  kparameter: '量程系数',
  minValue: '',
  maxValue: '',
  unit: ''
}];
export default {
  name: 'ParameterFilingModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  data: function data() {
    var _ref;

    return _ref = {
      Listvalue: [],
      upTitle: [],
      title: '关键参数备案表单',
      tableName: 'om_parameter_filing',
      form_fields: ['siteId', 'assetId', 'rangeValue', 'sort', 'rangeName', 'rangeValue', 'tenantId'],
      form_fields_time: [],
      assetBySiteIdList: [],
      validatorRules: {},
      paramColumns: paramColumns,
      partColumns: partColumns,
      parameterFilingItems: [],
      itemList: [],
      paramData: [],
      targetList: [],
      unitOptions: [],
      depName: '',
      productName: '',
      TotalSum: {},
      addParamDataIndex: 0,
      addFactorDataIndex: 0,
      timer: null,
      selectValue: '',
      url: {
        getAssetBySiteId: 'om/parameter/filing/queryAsset/'
      }
    }, _defineProperty(_ref, "validatorRules", {
      assetId: {
        rules: [{
          required: true,
          message: '请选择供应商!'
        }]
      }
    }), _defineProperty(_ref, "assetId", ''), _defineProperty(_ref, "siteId", ''), _defineProperty(_ref, "deleteAssetId", {}), _defineProperty(_ref, "activeKey", '1'), _defineProperty(_ref, "showInput", true), _ref;
  },
  props: ['pagePath'],
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {
    this.getDictionaries();
    this.queryUnitList();
  },
  computed: {},
  methods: {
    addTable1: function addTable1() {
      var _this = this;

      this.form.validateFields(function (err, values) {
        console.log(err);

        if (!err) {
          var newData = _toConsumableArray(_this.paramData);

          _this.addParamDataIndex++;
          newData.push({
            key: 'A1_' + _this.addParamDataIndex,
            //量程名称
            rangeName: '',
            //量程值
            rangeValue: '',
            sort: '',
            editable: true,
            assetId: _this.assetId,
            siteId: _this.siteId,
            parameterFilingItems: JSON.parse(JSON.stringify(_this.parameterFilingItems))
          });
          _this.paramData = newData;
          console.log('newData', newData); // this.cacheParamData = newData.map((item) => ({ ...item }))
        }
      });
    },
    delTable1: function delTable1(key) {
      var newData = this.paramData.filter(function (item) {
        return key != item.key;
      });
      this.paramData = newData;
      this.cacheParamData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
      this.Listvalue = newData;
    },
    add: function add() {
      this.edit({});
    },
    //查看数据
    ViewData: function ViewData(record) {
      var _this2 = this;

      console.log('record', record);
      this.model = Object.assign({}, record);
      this.visible = true; // debugger

      this.$nextTick(function () {
        var that = _this2; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields));
      });
    },
    //添加量程
    addList: function addList(record) {
      var _this3 = this;

      console.log('paramData', this.paramData);
      console.log('record', record);
      console.log('Listvalue', this.Listvalue);
      var state = false;
      record.editable = false;
      this.Listvalue.forEach(function (item, index) {
        // console.log('retusl', item)
        if (record.key == item.key) {
          console.log('record', _this3.Listvalue);
          var data = _this3.Listvalue[index];
          data.rangeName = record.rangeName;
          data.rangeValue = record.rangeValue;
          state = true;
        }
      });

      if (!state) {
        this.Listvalue.push(record);
      }

      console.log('record', this.Listvalue);
    },
    //编辑量程
    editList: function editList(record) {
      record.editable = true;
    },
    // 删除量程
    deleteList: function deleteList(record) {
      var _this4 = this;

      console.log('record删除', record);
      this.paramData.forEach(function (item, index) {
        if (item.key == record.key) {
          _this4.paramData.splice(index, 1);
        }
      });
      console.log('paramData', this.paramData);
      this.Listvalue.forEach(function (item, index) {
        if (item.key == record.key) {
          _this4.Listvalue.splice(index, 1);
        }
      });
      console.log('this.Listvalue', this.Listvalue);
    },
    //单位选择框
    queryUnitList: function queryUnitList() {
      var _this5 = this;

      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: '1'
      };
      getAction('/site/factor/unit', params).then(function (res) {
        if (res.success) {
          _this5.unitOptions = res.result.records;
        } else {
          console.log(res.message);
        }
      });
    },
    // 选择框改变
    selectChange: function selectChange(e) {
      // console.log('record.parameterFilingItems', e)
      // console.log('record.parameterFilingItems', this.Listvalue)
      var result = this.Listvalue.find(function (item) {
        return item.key == e;
      });
      this.itemList = result.parameterFilingItems;
    },
    //tab切换判断
    switchTab: function switchTab(e) {
      console.log('Listvalue', this.Listvalue);
      this.activeKey = e; // if (e == 2) {
      //   if (this.Listvalue.length > 0) {
      //     this.selectValue = this.Listvalue[0].key
      //     this.selectChange(this.selectValue)
      //   }
      // }
    },
    // 技术参数表格相关的操作函数
    // handleChangeTable1(value, key, column) {
    //   const newData = [...this.paramData]
    //   const target = newData.filter((item) => key === item.key)[0]
    //   console.log('target', value, key, column)
    //   this.targetList=target
    //   if (target) {
    //     target[column] = value
    //     this.paramData = newData
    //   }
    //   },
    edit: function edit(record) {
      var _this6 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true; // debugger

      if (this.model.id == undefined) {
        this.loadAssetBySiteId();
      }

      this.$nextTick(function () {
        var that = _this6; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      }); //加载产品信息
      // if (this.model.id || this.showTab == false) {
      //   this.loadProduct()
      // } else if (!this.model.id) {
      //   this.renderProductModel()
      // }
      // 查看关键参数备案

      if (this.model.assetId == record.assetId) {
        this.loadAssetBySiteId(record);
      }
    },
    //
    getDictionaries: function getDictionaries() {
      var _this7 = this;

      //根据字典Code, 初始化字典数组
      ajaxGetDictItems('parameter_filing').then(function (res) {
        // console.log('res------', res)
        if (res.success) {
          res.result.forEach(function (item) {
            _this7.parameterFilingItems.push({
              keyParameterStr: item.text,
              keyParameter: item.value,
              minValue: '',
              maxValue: '',
              unit: ''
            });
          });
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    DetectorSelect: function DetectorSelect(params, id) {
      var _this8 = this;

      this.selectValue = '';
      this.itemList = [];
      this.assetId = params;
      this.deleteAssetId['assetId'] = this.assetId;
      this.deleteAssetId['parameterFilingVos'] = [];
      console.log('assetId', this.form.assetId);
      var result = this.assetBySiteIdList.find(function (item) {
        console.log(item);
        return item.assetId == params;
      });
      this.depName = result.depName;
      this.productName = result.productName;
      this.Listvalue = [];
      this.paramData = []; // 通过资产id查询所有量程和量程子表

      queryRange(result.assetId).then(function (res) {
        res.result.forEach(function (item, index) {
          var parameterFilingItems = JSON.parse(JSON.stringify(_this8.parameterFilingItems));
          parameterFilingItems.forEach(function (item1) {
            var result = item.parameterFilingItems.find(function (item2) {
              return item2.keyParameter == item1.keyParameter;
            });

            if (result) {
              item1.minValue = result.minValue;
              item1.maxValue = result.maxValue;
              item1.unit = result.unit;
            }
          });
          _this8.addParamDataIndex++;

          _this8.Listvalue.push({
            rangeName: item.rangeName,
            rangeValue: item.rangeValue,
            key: 'A1_' + _this8.addParamDataIndex,
            parameterFilingItems: parameterFilingItems,
            assetId: item.assetId,
            siteId: item.siteId
          });

          _this8.paramData.push({
            rangeName: item.rangeName,
            rangeValue: item.rangeValue,
            editable: false,
            key: 'A1_' + _this8.addParamDataIndex,
            parameterFilingItems: parameterFilingItems
          });

          console.log('paramData', _this8.paramData);

          if (item.id == id) {
            console.log('this.Listvalue', _this8.Listvalue);

            if (_this8.Listvalue.length > 0) {
              _this8.selectValue = _this8.Listvalue[index].key;

              _this8.selectChange(_this8.selectValue);
            }
          }
        });
      });
    },
    loadAssetBySiteId: function loadAssetBySiteId(record) {
      var _this9 = this;

      var that = this;
      that.assetBySiteIdList = [];
      getAction(this.url.getAssetBySiteId + this.siteId).then(function (res) {
        if (res.success) {
          console.log('res.result', res.result);
          that.assetBySiteIdList = res.result;
        }

        if (record.assetId) {
          _this9.DetectorSelect(record.assetId, record.rangeId);
        }
      });
    },
    //提交表单信息
    handleOk: function handleOk() {
      var _this10 = this;

      if (this.Listvalue.length > 0) {
        this.form.validateFields(function (err, values) {
          console.log('err', err, 'values', values);

          if (!err) {
            _this10.TotalSum = JSON.parse(JSON.stringify(_this10.Listvalue));
            console.log(_this10.Listvalue);

            _this10.TotalSum.forEach(function (item) {
              item.parameterFilingItems = item.parameterFilingItems.filter(function (value) {
                if (!(value.maxValue == '' && value.minValue == '' && value.unit == '')) {
                  return value;
                }
              });
            });

            console.log('ParameterFiling', _this10.TotalSum);
            _this10.deleteAssetId['assetId'] = _this10.assetId;
            _this10.deleteAssetId['parameterFilingVos'] = _this10.TotalSum;
            newRange(_this10.deleteAssetId).then(function (res) {
              console.log('res', res);

              if (res.success) {
                _this10.$notification.success({
                  message: res.message
                });

                _this10.$emit('ok');

                _this10.close();
              } else {
                _this10.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        }).finally(function () {
          _this10.confirmLoading = false;
        });
      } else {
        this.form.validateFields(function (err, values) {
          if (!err) {
            newRange(_this10.deleteAssetId).then(function (res) {
              console.log('res', res);

              if (res.success) {
                _this10.$notification.success({
                  message: res.message
                });

                _this10.$emit('ok');

                _this10.close();
              } else {
                _this10.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        }).finally(function () {
          _this10.confirmLoading = false;
        });
      }
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};